<div>
  <h3 translate class="page-title text-center">ACTIVITIES</h3>
  <div class="row">
    <div class="col-12 text-right">
      <button type="button" class="btn btn-primary" (click)="openCreateModal()" translate>ACTIVITY_CREATE_NEW</button>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <lib-filter-list [configService]="cultActivityInternalListConfigService"></lib-filter-list>
      <!-- <lib-activity-internal-list></lib-activity-internal-list> -->
    </div>
  </div>
</div>
